module.exports = __webpack_public_path__ + "115854aa48c398cc9af7a2af51042b44.MP3";